import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import IconWrap from '../../IconWrap';
const Resale = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _object_spread_props(_object_spread({}, props), {
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M3.326 6.736a.9.9 0 101.273-1.272l-.526-.526h7.043v1.786a.9.9 0 001.8 0V4.138a1 1 0 00-1-1H3.998l.6-.602a.9.9 0 00-1.272-1.272l-2.03 2.029a1 1 0 000 1.414l2.03 2.03zM3.99 8.4c.565 0 .968.403.9.9v1.786h7.063l-.55-.55a1.059 1.059 0 010-1.272c.42-.352.99-.352 1.273 0l2.03 2.03a1 1 0 010 1.413l-2.03 2.03c-.283.351-.853.351-1.273 0a1.059 1.059 0 010-1.273l.578-.578H4.09a1 1 0 01-1-1V9.3c.068-.497.47-.9.9-.9z"
    })));
};
Resale.displayName = 'Resale';
export default Resale;

//# sourceMappingURL=Resale.js.map